import { Css, Icon, Tag, Tooltip, useTestIds } from "@homebound/beam";
import { pluralize } from "src/utils";

export function ConflictTag(props: { conflicts: string[]; asTag?: boolean }) {
  const { conflicts, asTag = true } = props;

  const tid = useTestIds({}, "conflictTag");

  const tooltipTitle = `Option conflict: This option cannot be selected with ${conflicts.join(
    ", ",
  )} option(s). Please deselect the other(s) to enable this option.`;

  if (asTag)
    return (
      <div css={Css.h2.wPx(100).$}>
        <Tooltip title={tooltipTitle} {...tid.tooltip}>
          <Tag text={`${conflicts.length} ${pluralize(conflicts.length, "conflict")}`} type="warning" />
        </Tooltip>
      </div>
    );

  return (
    <Tooltip title={tooltipTitle} {...tid.tooltip}>
      <div css={Css.df.gap1.aic.red200.$}>
        <Icon icon="errorCircle" /> {pluralize(conflicts.length, "Conflict")}
      </div>
    </Tooltip>
  );
}
